/** "2.4 MB": a file's size the way people say it, in decimal units as file browsers show. */
export function fileSize(bytes: number) {
  const units = ["bytes", "KB", "MB", "GB"];
  let value = bytes,
    unit = 0;
  while (value >= 1000 && unit < units.length - 1) {
    value /= 1000;
    unit++;
  }
  return unit === 0
    ? `${bytes} ${bytes === 1 ? "byte" : "bytes"}`
    : `${value >= 10 ? Math.round(value) : value.toFixed(1)} ${units[unit]}`;
}
